export default __webpack_public_path__ + "static/focus2-min-e67f1eab12480a0317f75dd43d7a0083.png";